import withAnalytics from './withAnalytics';
import withLayout from './withLayout';

export { withAnalytics, withLayout };



// WEBPACK FOOTER //
// ./src/hocs/index.js